import {component} from '../components/form/Constant'
import {convertKeyToLabel} from '../components/table-utils/TableUtils'

export const aiFormKeys = {
    observation: 'observation',
    compareWith: 'compareWith',
    timeOrRecord: 'timeOrRecord',
    question: 'question',
    time: 'time',
    record: 'record',
}
export const aiOptionsValue = {
    onlyCurrent: 'onlyCurrent',
    compareWith: 'compareWith',
    time: aiFormKeys.time,
    record: aiFormKeys.record,
}
const obsOption = [
    {
        label: 'The current observation based on the set parameters',
        value: aiOptionsValue.onlyCurrent,
    },
    {
        label: 'Compare the current observation with other observations based on the set parameters',
        value: aiOptionsValue.compareWith,
    },
]
const timeOrRecordOption = [
    {label: 'Time', value: aiOptionsValue.time},
    {label: 'Record', value: aiOptionsValue.record},
]

function getTimeOrRecordOptions(key) {
    let option = []
    if (key) {
        for (let i = 1; i < 10; i++) {
            let item = {
                label: `${i} ${convertKeyToLabel(key)}`,
                value: i,
            }
            option.push(item)
        }
    }
    return option
}

const recordOption = [
    {label: 'The latest record', value: 2},
    {label: '6 latest records', value: 6},
    {label: '12 latest records', value: 12},
    {label: '24 latest records', value: 24},
    {label: '36 latest records', value: 36},
    {label: '48 latest records', value: 48},
    {label: '60 latest records', value: 60},
]

export const obsAiDataList = [
    {
        key: aiFormKeys.observation,
        label: 'Observation',
        options: obsOption,
        component: component.dropdown,
        isShow: true,
    },
    {
        key: aiFormKeys.compareWith,
        label: 'Compare With',
        component: component.multiSelect,
        className: 'col-6',
    },
    // {
    //     key: aiFormKeys.timeOrRecord,
    //     label: 'Date Time / Record',
    //     options: timeOrRecordOption,
    //     component: component.dropdown,
    //     className: 'col-6',
    // },
    // {
    //     key: aiFormKeys.time,
    //     label: 'Time',
    //     options: getTimeOrRecordOptions('day'),
    //     component: component.dropdown,
    //     className: 'col-6',
    // },
    {
        key: aiFormKeys.record,
        label: 'Record',
        options: recordOption,
        component: component.dropdown,
        className: 'col-6',
    },
]
